window.addEventListener("scroll", function() {
  if (window.pageYOffset > 746) {
    document.querySelector(".search-bar").classList.add("fixed");
  } else {
    document.querySelector(".search-bar").classList.remove("fixed");
  }
});
